/* AD DEFENSE – refonte 2026 : menu « panneau de commandement » (ordinateur) + menu plein écran (mobile) */
(function () {
  var html = document.documentElement;

  /* ---------------------------------------------------------- Ordinateur */
  var nav = document.querySelector('.dfz-nav');
  if (nav) {
    var items = [].slice.call(nav.querySelectorAll('.dfz-nav__item.has-panel'));
    var openItem = null, tOpen = null, tClose = null;

    function panelOf(item) { return document.getElementById(item.getAttribute('data-panel')); }

    function open(item) {
      clearTimeout(tClose);
      if (openItem === item) return;
      if (openItem) close(true);
      var p = panelOf(item);
      if (!p) return;
      p.hidden = false;
      requestAnimationFrame(function () { p.classList.add('is-open'); });
      item.classList.add('is-open');
      var btn = item.querySelector('button.dfz-nav__top');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      nav.classList.add('has-open');
      openItem = item;
    }
    function close(instant) {
      if (!openItem) return;
      var item = openItem, p = panelOf(item);
      item.classList.remove('is-open');
      var btn = item.querySelector('button.dfz-nav__top');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      p.classList.remove('is-open');
      if (instant) p.hidden = true; else setTimeout(function () { if (!p.classList.contains('is-open')) p.hidden = true; }, 260);
      nav.classList.remove('has-open');
      openItem = null;
    }

    items.forEach(function (item) {
      var p = panelOf(item);
      item.addEventListener('mouseenter', function () { clearTimeout(tOpen); tOpen = setTimeout(function () { open(item); }, openItem ? 0 : 110); });
      item.addEventListener('mouseleave', function () { clearTimeout(tOpen); });
      var btn = item.querySelector('button.dfz-nav__top');
      if (btn) btn.addEventListener('click', function () { if (openItem === item) close(); else open(item); });

      // Survol d'une sous-catégorie → aperçu correspondant
      [].slice.call(p.querySelectorAll('.dfz-row')).forEach(function (row) {
        function show() {
          var k = row.getAttribute('data-row');
          p.querySelectorAll('.dfz-row').forEach(function (r) { r.classList.toggle('is-active', r === row); });
          p.querySelectorAll('.dfz-preview').forEach(function (pv) {
            var on = pv.getAttribute('data-row') === k;
            pv.hidden = !on;
            pv.classList.toggle('is-active', on);
          });
        }
        row.addEventListener('mouseenter', show);
        row.addEventListener('focus', show);
      });
    });

    nav.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(close, 220); });
    nav.addEventListener('mouseenter', function () { clearTimeout(tClose); });
    nav.querySelector('.dfz-nav__scrim').addEventListener('click', function () { close(); });
    // La zone sombre fait partie du menu dans la page : la survoler vaut « sortir »
    nav.querySelector('.dfz-nav__scrim').addEventListener('mouseenter', function () { clearTimeout(tOpen); tClose = setTimeout(close, 220); });
    [].slice.call(nav.querySelectorAll('.dfz-panel, .dfz-nav__bar')).forEach(function (el) {
      el.addEventListener('mouseenter', function () { clearTimeout(tClose); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        var btn = openItem.querySelector('.dfz-nav__top');
        close();
        if (btn) btn.focus();
      }
    });
    // Clavier : quitter le panneau avec Tab referme
    nav.addEventListener('focusout', function (e) { if (!nav.contains(e.relatedTarget)) close(); });
  }

  /* -------------------------------------------------------------- Mobile */
  var m = document.querySelector('.dfz-mnav');
  if (m) {
    var panel = m.querySelector('.dfz-mnav__panel');
    // Sorti de l'en-tête pour passer au-dessus de tout (bandeau d'annonce compris)
    document.body.appendChild(panel);
    var opener = m.querySelector('.dfz-mnav__open');
    var screens = [].slice.call(panel.querySelectorAll('.dfz-mnav__screen'));

    function show(id, back) {
      screens.forEach(function (s) {
        var on = s.getAttribute('data-screen') === id;
        if (on) {
          s.hidden = false;
          s.classList.remove('from-left', 'from-right');
          s.classList.add(back ? 'from-left' : 'from-right');
          void s.offsetWidth;
          s.classList.add('is-active');
        } else {
          s.classList.remove('is-active');
          s.hidden = true;
        }
      });
      panel.scrollTop = 0;
    }
    function openM() {
      panel.hidden = false;
      show('root', true);
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      html.classList.add('dfz-mnav-open');
      opener.setAttribute('aria-expanded', 'true');
      var c = panel.querySelector('.dfz-mnav__close'); if (c) c.focus();
    }
    function closeM() {
      panel.classList.remove('is-open');
      html.classList.remove('dfz-mnav-open');
      opener.setAttribute('aria-expanded', 'false');
      setTimeout(function () { panel.hidden = true; }, 300);
      opener.focus();
    }
    opener.addEventListener('click', openM);
    panel.querySelector('.dfz-mnav__close').addEventListener('click', closeM);
    panel.querySelectorAll('[data-go]').forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-go')); }); });
    panel.querySelectorAll('.dfz-mnav__back').forEach(function (b) { b.addEventListener('click', function () { show('root', true); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) closeM(); });
    // Fermer si on repasse en affichage ordinateur
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (q) { if (q.matches && !panel.hidden) closeM(); });
  }
})();
